import PropTypes from "prop-types";
import { createContext, useEffect, useReducer } from "react";

// third-party

import jwtDecode from "jwt-decode";

// reducer - state management
import { ENABLE_OTP, LOGIN, LOGOUT } from "store/actions";
import accountReducer from "store/accountReducer";

// project imports
import Loader from "ui-component/Loader";
import axios from "utils/axios";
import { enableOtp, loginAPI, registerAPI } from "../apis/api";
import { useNavigate } from "react-router-dom";

// constant
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
    return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  if (decoded.exp > Date.now() / 1000) {
    return true;
  } else {
    return false;
  }
};

const setSession = (serviceToken) => {
  if (serviceToken) {
    localStorage.setItem("serviceToken", serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    localStorage.removeItem("serviceToken");
    delete axios.defaults.headers.common.Authorization;
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(accountReducer, initialState);
  const navigate = useNavigate();
  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = window.localStorage.getItem("serviceToken");
        if (serviceToken && verifyToken(serviceToken)) {
          setSession(serviceToken);
          dispatch({
            type: LOGIN,
            payload: {
              isLoggedIn: true,
              serviceToken,
            },
          });
        } else {
          dispatch({
            type: LOGOUT,
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: LOGOUT,
        });
      }
    };

    init();
  }, []);

  const login = async (registryNo, password) => {
    const response = await enableOtp({ registryNo: Number(registryNo), password: password });
    if (response.status === 400) {
      return response;
    }
    const cellPhone = response.data.data;
    dispatch({
      type: ENABLE_OTP,
      payload: {
        cellPhone,
        pwd: password,
        registryNo: Number(registryNo),
      },
    });
    navigate("/otp-confirmation");
  };

  const authorize = (token) => {
    try {
      setSession(token);
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          token,
        },
      });
      dispatch({
        type: ENABLE_OTP,
        payload: {
          cellPhone: "",
          pwd: "",
          registryNo: "",
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const register = async (registryNo, password) => {
    // todo: this flow need to be recode as it not verified
    const response = await registerAPI({ registryNo: Number(registryNo), password: password });
    let users = response.data;
    window.localStorage.setItem("users", JSON.stringify(users));
    return response;
  };

  const logout = () => {
    setSession(null);
    dispatch({ type: LOGOUT });
  };

  const resetPassword = (email) => {};

  const updateProfile = () => {};

  // const loginWithQr = async (token) => {
  //   const isValid = verifyToken(token);
  //   if (isValid) {
  //     dispatch({
  //       type: LOGIN,
  //       payload: {
  //         isLoggedIn: true,
  //         token,
  //       },
  //     });
  //     setSession(token);
  //   }
  //   return isValid;
  // };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        authorize,
        register,
        resetPassword,
        updateProfile,
        // loginWithQr,
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

JWTProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default JWTContext;
